import React, { useMemo } from 'react';
import './MeterTable.css';

const MeterTable = ({ meters, service = null }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  };

  // Обрабатываем новую структуру данных: каждый meter = одна дата с массивом readings
  const tableData = useMemo(() => {
    if (!meters || meters.length === 0) {
      return { meterIndices: [], rows: [] };
    }

    // Определяем количество счетчиков из первой записи или service
    let meterCount = 0;
    if (service && Array.isArray(service.tariffs)) {
      meterCount = service.tariffs.length;
    } else if (meters.length > 0 && Array.isArray(meters[0].readings)) {
      meterCount = Math.max(...meters.map(m => 
        m.readings ? Math.max(...m.readings.map(r => r.index + 1), 0) : 0
      ));
    }

    const meterIndices = Array.from({ length: meterCount }, (_, i) => i);

    // Преобразуем данные для таблицы
    const rows = meters.map(meter => {
      const readingsMap = {};
      if (Array.isArray(meter.readings)) {
        meter.readings.forEach(r => {
          readingsMap[r.index] = r.reading;
        });
      }

      return {
        date: meter.date,
        readings: readingsMap,
        total_sum: meter.total_sum || 0,
      };
    });

    return { meterIndices, rows };
  }, [meters, service]);

  const { meterIndices, rows } = tableData;

  if (!meters || meters.length === 0) {
    return (
      <div className="meter-table-empty">
        <p>Нет данных счетчиков для этой услуги</p>
      </div>
    );
  }

  return (
    <div className="meter-table-container">
      <table className="meter-table">
        <thead>
          <tr>
            <th>Дата</th>
            {meterIndices.map(index => (
              <th key={index}>{service.tariffs[index].name}</th>
            ))}
            <th className="sum-header">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.date}>
              <td className="date-cell">{formatDate(row.date)}</td>
              {meterIndices.map(index => (
                <td key={index} className="reading-value">
                  {row.readings[index] !== undefined ? row.readings[index] : '-'}
                </td>
              ))}
              <td className="sum-cell">
                <strong>{row.total_sum.toFixed(2)} грн</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MeterTable;
